import 'css-chunksrc/client/pages/projectPage/discussionsPage/creationMenu/styles.scss';export default {
  "creationMenu": "_creationMenu_ea44j_1",
  "button": "_button_ea44j_5",
  "icon": "_icon_ea44j_25",
  "iconBox": "_iconBox_ea44j_33",
  "menu": "_menu_ea44j_42",
  "menuItem": "_menuItem_ea44j_54",
  "menuText": "_menuText_ea44j_67",
  "fileIcon": "_fileIcon_ea44j_85",
  "lockIcon": "_lockIcon_ea44j_90",
  "block": "_block_ea44j_94"
};